import { useCallback, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { RootStoreContext } from "src/stores/RootStore";
import { INewsListFilter } from "src/stores/NewsListStore";

// Changes the filter of the page "News". The page of the list lives in the store, which starts a changed filter
// on page 1. The list also writes its page into the URL and reads it back when it starts on page 1, so a changed
// filter removes the page from the URL in the same step.
export const useNewsListFilter = () => {
    const { newsListStore } = useContext(RootStoreContext);
    const history = useHistory();
    const location = useLocation();

    const changeFilter = useCallback(
        (change: () => void) => {
            const filterBefore = newsListStore.filter;
            change();
            if (newsListStore.filter === filterBefore) return;

            const urlQuery = new URLSearchParams(location.search);
            if (!urlQuery.has("page")) return;

            urlQuery.delete("page");
            history.replace({ search: urlQuery.toString() });
        },
        [newsListStore, history, location.search]
    );

    const setFilter = useCallback(
        (changes: Partial<INewsListFilter>) => changeFilter(() => newsListStore.setFilter(changes)),
        [changeFilter, newsListStore]
    );

    const setSearchTag = useCallback(
        (id: string, active: boolean) => changeFilter(() => newsListStore.setSearchTag(id, active)),
        [changeFilter, newsListStore]
    );

    const clearFilter = useCallback(
        () => changeFilter(() => newsListStore.clearFilter()),
        [changeFilter, newsListStore]
    );

    return { setFilter, setSearchTag, clearFilter };
};
